// Port of api/fuel/app/classes/insights/hindex/designers.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'designers',
    priority: 1,
    default_: true,
    requires: ['init'],
    insight: false,
    detail: [],
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!this._data.track || !this._data.track.get_hindex()) return {}
        if (!owner.get_count_collection || !owner.get_count_collection()) return {}

        var collectionIndex = this._data.current.get_index_level()

        var limit = detail ? 100 : 5
        var ranked = []

        if (collectionIndex.length) {

            var sorted = Util.query(
                'SELECT COUNT(DISTINCT game_id) AS collected, designer_id AS designer,' +
                ' MIN(game_designer_id) AS first_link' +
                ' FROM game_designer' +
                ' WHERE game_id IN (' + Util.in(collectionIndex) + ')' +
                ' AND designer_id NOT IN(3)' +
                ' GROUP BY designer_id' +
                ' ORDER BY COUNT(DISTINCT game_id) DESC, MIN(game_designer_id) ASC' +
                ' LIMIT 0, ' + limit
            )

            var index = Util.pluck(sorted, 'designer')

            if (index.length) {

                var applicableGames = Util.query(
                    'SELECT game_id AS game, designer_id AS designer' +
                    ' FROM game_designer' +
                    ' WHERE designer_id IN (' + Util.in(index) + ')' +
                    ' AND game_id IN (' + Util.in(collectionIndex) + ')'
                )

                var applicableGameIndex = Util.pluck(applicableGames, 'game')

                var applicableGamesGrouped = {}
                for (var gi = 0; gi < applicableGames.length; gi++) {
                    var link = applicableGames[gi]
                    if (!applicableGamesGrouped[link.designer]) applicableGamesGrouped[link.designer] = []
                    applicableGamesGrouped[link.designer].push(parseInt(link.game, 10))
                }

                var ratings = Util.query(
                    'SELECT AVG(r.rating_value) AS rating, r.game_id AS game' +
                    ' FROM rating r' +
                    ' WHERE r.game_id IN (' + Util.in(applicableGameIndex) + ')' +
                    ' AND r.user_id IN (' + Util.in(userIndex) + ')' +
                    ' GROUP BY r.game_id',
                    null, 'game'
                )

                var details = Util.query(
                    'SELECT * FROM designer WHERE designer_id IN (' + Util.in(index) + ')',
                    null, 'designer_id'
                )

                for (var si = 0; si < sorted.length; si++) {
                    var item = sorted[si]
                    var gameRatings = []

                    if (applicableGamesGrouped[item.designer]) {
                        for (var gj = 0; gj < applicableGamesGrouped[item.designer].length; gj++) {
                            var gameId = applicableGamesGrouped[item.designer][gj]
                            gameRatings.push({
                                id: gameId,
                                rating: (ratings[gameId] && ratings[gameId].rating) ? parseFloat(ratings[gameId].rating) : '-'
                            })
                        }
                    }

                    gameRatings = gameRatings.slice().sort(function(a, b) {
                        var ar = (a.rating === '-') ? 0 : a.rating
                        var br = (b.rating === '-') ? 0 : b.rating
                        return ar !== br ? br - ar : a.id - b.id
                    })

                    for (var ri = 0; ri < 3 && ri < gameRatings.length; ri++) {
                        this._references.games.push(gameRatings[ri].id)
                    }

                    ranked.push({
                        id: details[item.designer] ? parseInt(details[item.designer].designer_id, 10) : parseInt(item.designer, 10),
                        name: details[item.designer] ? details[item.designer].designer_name : '',
                        count: parseInt(item.collected, 10),
                        games: gameRatings.slice(0, 3)
                    })
                }

            }

        }

        return {
            designers: ranked
        }

    }
})
